import ComicCard from '@/components/base/ComicCard';
import { editorPickComics } from '@/mocks/comics';

export default function EditorPicks() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-12">
          <h2 className="font-heading text-[32px] md:text-[48px] font-black text-foreground-900 leading-tight">
            编辑精选
          </h2>
          <h3 className="font-heading text-[32px] md:text-[48px] font-black text-foreground-900 leading-tight">
            每日推荐
          </h3>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {editorPickComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} variant="editor" />
          ))}
        </div>
      </div>
    </section>
  );
}